'use client';
import Image from 'next/image';

const galleryImages = [
  '/images/event-highlights/gallery-01.webp',
  '/images/event-highlights/gallery-02.webp',
  '/images/event-highlights/gallery-03.webp',
  '/images/event-highlights/gallery-04.webp',
  '/images/event-highlights/welcom.webp',
  '/images/event-highlights/new-era.webp',
  '/images/event-highlights/happy.webp',
  '/images/event-highlights/speakers-on-chair.webp',
  '/images/event-highlights/netwoking.webp',
  '/images/event-highlights/thought.webp',
  // '/images/event-highlights/selfie.webp',
  '/images/event-highlights/discuss.webp',
  '/images/event-highlights/exchnage.webp',
  // '/images/event-highlights/network.webp',
  // // '/images/event-highlights/crowd.webp',
  // '/images/event-highlights/speaker-panel.webp',
  // '/images/event-highlights/people.webp',
  // '/images/event-highlights/all-speaker.webp',

];

export default function GallerySection() {
  return (
<section data-component-id="src/app/GallerySection.tsx:28:0" data-component-path="src/app/GallerySection.tsx" data-component-line="28" data-component-file="GallerySection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22event-highlights%22%2C%22className%22%3A%22w-full%20bg-white%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%22%7D" id='event-highlights' className="w-full bg-white p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4"
    >      {/* Heading */}
      <h2 data-component-id="src/app/GallerySection.tsx:30:6" data-component-path="src/app/GallerySection.tsx" data-component-line="30" data-component-file="GallerySection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B20px%5D%20mb-10%20sm%3Atext-%5B24px%5D%20lg%3Atext-3xl%20font-semibold%20leading-%5B28px%5D%20sm%3Aleading-%5B32px%5D%20lg%3Aleading-4xl%20text-center%20text-text-accent%20font-poppins%22%2C%22textContent%22%3A%22Event%20Highlights%22%7D" className="text-[20px] mb-10 sm:text-[24px] lg:text-3xl font-semibold leading-[28px] sm:leading-[32px] lg:leading-4xl text-center text-text-accent font-poppins">
        Event Highlights
      </h2>

      {/* Gallery Grid */}
      <div data-component-id="src/app/GallerySection.tsx:35:6" data-component-path="src/app/GallerySection.tsx" data-component-line="35" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%20grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20gap-3%20sm%3Agap-4%22%7D" className="max-w-[1200px] mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
        {galleryImages.map((src, index) => (
          <div data-component-id="src/app/GallerySection.tsx:37:10" data-component-path="src/app/GallerySection.tsx" data-component-line="37" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20group%20overflow-hidden%20rounded-lg%22%7D"
            key={index}
            className="relative group overflow-hidden rounded-lg"
          >
            <Image data-component-id="src/app/GallerySection.tsx:41:12" data-component-path="src/app/GallerySection.tsx" data-component-line="41" data-component-file="GallerySection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20transition-transform%20duration-500%20group-hover%3Ascale-105%22%7D"
              src={src}
              alt={`Gallery ${index + 1}`}
              width={500}
              height={500}
              unoptimized
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />

            {/* Gradient Overlay */}
            <div data-component-id="src/app/GallerySection.tsx:51:12" data-component-path="src/app/GallerySection.tsx" data-component-line="51" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20group-hover%3Aopacity-0%20transition-opacity%20duration-500%22%7D" className="absolute inset-0 group-hover:opacity-0 transition-opacity duration-500" />
          </div>
        ))}
      </div>
    </section>
  );
}
